import { Action } from "../actions/types"
import { VehicleServiceType, VehicleServiceActionList } from "../actions/vehicleServiceActions"

const initialValue: Array<VehicleServiceType> = []

const vehicleServiceReducer = (state: Array<VehicleServiceType> = initialValue, action: Action) => {
    switch (action.type) {

        case VehicleServiceActionList.ADD_VEHICLE_SERVICE:
            return [
                ...state,
                action.data,
            ]

        case VehicleServiceActionList.UPDATE_VEHICLE_SERVICE:
            const updated = [...state].slice()
            const index = updated.findIndex(u => u.id === action.data.id)

            if (index > -1) {
                updated[index] = {
                    ...action.data
                }
            }

            return updated

        case VehicleServiceActionList.FETCH_VEHICLE_SERVICE:
            return action.data

        case VehicleServiceActionList.DELETE_VEHICLE_SERVICE:
            return state.filter(s => s.id !== action.data)

        default:
            return state
    }
}

export default vehicleServiceReducer